// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__X5aGg","title":"Images90_title__R7TmK","images":"Images90_images__IDQhE"};